import { inject, reactive, toRef } from 'vue';
import { ROUTE_CONTEXT } from '../api/keys';
export const useRouteContext = () => inject(ROUTE_CONTEXT, reactive({
    pathname: '',
    outlet: () => null,
    params: {},
    route: null,
}));
export const useOutlet = () => {
    return toRef(useRouteContext(), 'outlet');
};
